import React, { useState } from 'react'
import Title from '../../../../Common/Title'
import ButtonOutline from '../../../../Common/fCard/ButtonOutline';
import { post } from '../../../../../Model/Network/Config/Axios';
import { showToast } from '../../../../Common/fToast/ToastCallback';
import { useParams } from "react-router-dom";

function IntegrationTimeLine({init,data}) {
    let {id} = useParams();        
    const [show,setShow] = useState(false);

    if(!(data && data.integration)){
        return <></>
    }

    return (
        <div id="Invoice_Timeline" className='FadeRight-Effect' style={{backgroundColor:'#fff',padding:'0.25rem 1rem',borderRadius:'10px',marginTop:'1rem'}}>
            <div style={{'display':'flex','justifyContent':'space-between',alignItems:'center'}}>
                <div onClick={() => {setShow((!show))}}><Title id="timeline" marginLeft={0} title="Integration Timeline"/></div>
                <div style={{'border':'1px solid black', 'borderRadius':'100%', width:'18px',height:'18px','display':'flex','justifyContent':'center', 'alignItems':'center',cursor:'pointer'}} onClick={() => {setShow((!show))}}>
                    <img style={{width:12,transform:!show?'rotate(0deg)':'rotate(180deg)'}} src={require('./down.png')} alt="down"/>
                </div> 
            </div>
            {(show)?<div style={{marginLeft:'1rem'}}>
                <div className='timeline' style={{paddingLeft:'2rem'}}>
                    <div className="track"></div>
                    <div>
                        <div className="track-fill"/>
                    </div>
                    <div>
                        {
                            data.integration && data.integration.postingTriggered ?
                            <div className="stage">
                                <div className="track-point">
                                    <div className='point'><svg className="bi bi-check-lg" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16"><path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"></path></svg></div>
                                    <div className='point-text'><span>Posting Triggered</span></div>
                                </div>
                            </div>
                            :
                            null
                        }
                        {
                            data.integration && data.integration.postingFailed ?
                            <div className="stage">
                                <div className="track-point">
                                    <div style={{backgroundColor:'#DC0000'}} className='point-pending'>{false}</div>
                                    <div style={{display:'flex',flexDirection:'column'}} className='point-text'>
                                        <span>Posting Sync Failed</span>
                                        {(data.integration && data.integration.postingErrors)?<span>Error : {data.integration && data.integration.postingErrors}</span>:null}
                                            <ButtonOutline style={{ width:'100px',marginTop:'1rem'}} title={"Retrigger"} onClick={()=>{
                                                post('workspace/integration/triggerPosting', {
                                                    "formType": "purchase-order",
                                                    "formId": Number(id)
                                                }, (e, r) => {
                                                    if (r) {
                                                        showToast({
                                                            type: 'success',
                                                            message: "Integration retriggered successfully"
                                                        })
                                                        init();
                                                    } else {
                                                        showToast({
                                                            type: 'error',
                                                            message: e.data.message
                                                        })
                                                    }
                                                })
                                        }}/>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                        }
                        {
                            data.integration && data.integration.postingSynced ?
                            <div className="stage">
                                <div className="track-point">
                                <div className='point'><svg className="bi bi-check-lg" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16"><path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"></path></svg></div>
                                    <div className='point-text' style={{display:'flex',flexDirection:'column'}}>
                                        <span>Posting Sync - Successful</span>
                                        {(data.integration && data.integration.postingDocNo)?<span>Doc Number : {data.integration.postingDocNo}</span>:null}
                                    </div>
                                </div>
                            </div>
                            :
                            null
                        }
                    </div>
                </div>
            </div>:null}
        </div>
    )
}

export default IntegrationTimeLine